export function PLAAttributeBoolean(props: {
   value: unknown;
   label: string;
   readOnly?: boolean;
   onChange?: (value: boolean) => void;
}) {
   return (
      <input
         type="checkbox"
         checked={props.value === true}
         disabled={props.readOnly}
         aria-label={props.label}
         onChange={(event) => props.onChange?.(event.currentTarget.checked)}
      />
   );
}
